import { sendError } from './helpers';

export type CurrencyType = 'USD' | 'CAD' | '' | null;
export const USD = 'USD';
export const CAD = 'CAD';
export const USDCurrencyId = 1;
export const CADCurrencyId = 2;

export const FIVE_YEAR_USD_TO_CAD_AVERAGE = 1.3465; // keep in sync with the FIVE_YEAR_USD_TO_CAD_AVERAGE in Currency.php

export const isUsdString = (currency: CurrencyType): boolean => {
    return currency.toUpperCase() === USD;
};

export const isCadString = (currency: CurrencyType): boolean => {
    return currency.toUpperCase() === CAD;
};

export const convertCurrencyIdToString = (currencyId: number): string => {
    if (currencyId !== 1 && currencyId !== 2) {
        sendError(new Error(`Unexpected currency id ${currencyId}`));
    }
    if (currencyId === 2) {
        return CAD;
    }
    return USD;
};

export const convertCurrencyIdToCurrencyType = (currencyId: number): CurrencyType => {
    const currency = convertCurrencyIdToString(currencyId);
    return currency as CurrencyType;
};

export const convertLocalCurrencyToUSD = (
    currency: CurrencyType,
    localPriceDollars: number
): number => {
    return isCadString(currency)
        ? localPriceDollars / FIVE_YEAR_USD_TO_CAD_AVERAGE
        : localPriceDollars;
};

/**
 * Formats a number as currency (USD).
 * Returns 'N/A' if the input is null.
 */
export const formatCurrency = (num: number | null): string =>
    num === null ? 'N/A' : `$${num.toLocaleString('en-US')}`;

/** formatCurrency for an optional amount. No amount gives null, so a caller can leave the line out. */
export const formatOptionalCurrency = (num?: number | null): string | null =>
    num === undefined || num === null ? null : formatCurrency(num);
